var dhtmlDragAndDropObject = (function () {
    function dhtmlDragAndDropObject() {
        this.lastLanding = 0;
        this.dragNode = 0;
        this.dragStartNode = 0;
        this.dragStartObject = 0;
        this.tempDOMU = null;
        this.tempDOMM = null;
        this.waitDrag = 0;
        window.dhtmlDragAndDrop = this;
        return this;
    }
    dhtmlDragAndDropObject.prototype.removeDraggableItem = function (a) {
        a.onmousedown = null;
        a.dragStarter = null;
        a.dragLanding = null;
    };
    dhtmlDragAndDropObject.prototype.addDraggableItem = function (a, c) {
        a.onmousedown = this.preCreateDragCopy;
        a.dragStarter = c;
        this.addDragLanding(a, c);
    };
    dhtmlDragAndDropObject.prototype.addDragLanding = function (a, c) {
        a.dragLanding = c;
    };
    dhtmlDragAndDropObject.prototype.preCreateDragCopy = function (a) {
        if ((a || window.event) && (a || event).button == 2) {
            return;
        }
        if (window.dhtmlDragAndDrop.waitDrag) {
            window.dhtmlDragAndDrop.waitDrag = 0;
            document.body.onmouseup = window.dhtmlDragAndDrop.tempDOMU;
            document.body.onmousemove = window.dhtmlDragAndDrop.tempDOMM;
            return false;
        }
        if (window.dhtmlDragAndDrop.dragNode) {
            window.dhtmlDragAndDrop.stopDrag(a);
        }
        window.dhtmlDragAndDrop.waitDrag = 1;
        window.dhtmlDragAndDrop.tempDOMU = document.body.onmouseup;
        window.dhtmlDragAndDrop.tempDOMM = document.body.onmousemove;
        window.dhtmlDragAndDrop.dragStartNode = this;
        window.dhtmlDragAndDrop.dragStartObject = this.dragStarter;
        document.body.onmouseup = window.dhtmlDragAndDrop.preCreateDragCopy;
        document.body.onmousemove = window.dhtmlDragAndDrop.callDrag;
        window.dhtmlDragAndDrop.downtime = new Date().valueOf();
        if (a && a.preventDefault) {
            a.preventDefault();
            return false;
        }
        return false;
    };
    dhtmlDragAndDropObject.prototype.callDrag = function (g) {
        if (!g) {
            g = window.event;
        }
        var dragger = window.dhtmlDragAndDrop;
        if (new Date().valueOf() - dragger.downtime < 100) {
            return;
        }
        if (!dragger.dragNode) {
            if (dragger.waitDrag) {
                dragger.dragNode = dragger.dragStartObject._createDragNode(dragger.dragStartNode, g);
                if (!dragger.dragNode) {
                    return dragger.stopDrag();
                }
                dragger.dragNode.onselectstart = function () {
                    return false;
                };
                dragger.gldragNode = dragger.dragNode;
                document.body.appendChild(dragger.dragNode);
                document.body.onmouseup = dragger.stopDrag;
                dragger.waitDrag = 0;
                dragger.dragNode.pWindow = window;
                dragger.initFrameRoute();
            }
            else {
                return dragger.stopDrag(g, true);
            }
        }
        if (dragger.dragNode.parentNode != window.document.body &&
            dragger.gldragNode) {
            var a = dragger.gldragNode;
            if (dragger.gldragNode.old) {
                a = dragger.gldragNode.old;
            }
            a.parentNode.removeChild(a);
            var c = dragger.dragNode.pWindow;
            if (a.pWindow && a.pWindow.dhtmlDragAndDrop.lastLanding) {
                a.pWindow.dhtmlDragAndDrop.lastLanding.dragLanding._dragOut(a.pWindow.dhtmlDragAndDrop.lastLanding);
            }
            if (window._isIE) {
                var l = document.createElement("Div");
                l.innerHTML = dragger.dragNode.outerHTML;
                dragger.dragNode = l.childNodes[0];
            }
            else {
                dragger.dragNode = dragger.dragNode.cloneNode(true);
            }
            dragger.dragNode.pWindow = window;
            dragger.gldragNode.old = dragger.dragNode;
            document.body.appendChild(dragger.dragNode);
            c.dhtmlDragAndDrop.dragNode = dragger.dragNode;
        }
        dragger.dragNode.style.left =
            g.clientX +
                15 +
                (dragger.fx ? dragger.fx * -1 : 0) +
                (document.body.scrollLeft || document.documentElement.scrollLeft) +
                "px";
        dragger.dragNode.style.top =
            g.clientY +
                3 +
                (dragger.fy ? dragger.fy * -1 : 0) +
                (document.body.scrollTop || document.documentElement.scrollTop) +
                "px";
        if (!g.srcElement) {
            var h = g.target;
        }
        else {
            h = g.srcElement;
        }
        dragger.checkLanding(h, g);
    };
    dhtmlDragAndDropObject.prototype.calculateFramePosition = function (h) {
        if (window.name) {
            var e = parent.frames[window.name].frameElement.offsetParent;
            var g = 0;
            var c = 0;
            while (e) {
                g += e.offsetLeft;
                c += e.offsetTop;
                e = e.offsetParent;
            }
            if (parent.dhtmlDragAndDrop) {
                var a = parent.dhtmlDragAndDrop.calculateFramePosition(1);
                g += a.split("_")[0] * 1;
                c += a.split("_")[1] * 1;
            }
            if (h) {
                return g + "_" + c;
            }
            else {
                this.fx = g;
            }
            this.fy = c;
        }
        return "0_0";
    };
    dhtmlDragAndDropObject.prototype.checkLanding = function (c, a) {
        if (c && c.dragLanding) {
            if (this.lastLanding) {
                this.lastLanding.dragLanding._dragOut(this.lastLanding);
            }
            this.lastLanding = c;
            this.lastLanding = this.lastLanding.dragLanding._dragIn(this.lastLanding, this.dragStartNode, a.clientX, a.clientY, a);
            this.lastLanding_scr = window._isIE ? a.srcElement : a.target;
        }
        else {
            if (c && c.tagName != "BODY") {
                this.checkLanding(c.parentNode, a);
            }
            else {
                if (this.lastLanding) {
                    this.lastLanding.dragLanding._dragOut(this.lastLanding, a.clientX, a.clientY, a);
                }
                this.lastLanding = 0;
                if (this._onNotFound) {
                    this._onNotFound();
                }
            }
        }
    };
    dhtmlDragAndDropObject.prototype.stopDrag = function (c, g) {
        var dragger = window.dhtmlDragAndDrop;
        if (!g) {
            dragger.stopFrameRoute();
            var a = dragger.lastLanding;
            dragger.lastLanding = null;
            if (a) {
                a.dragLanding._drag(dragger.dragStartNode, dragger.dragStartObject, a, window._isIE ? event.srcElement : c.target);
            }
        }
        dragger.lastLanding = null;
        if (dragger.dragNode && dragger.dragNode.parentNode == document.body) {
            dragger.dragNode.parentNode.removeChild(dragger.dragNode);
        }
        dragger.dragNode = 0;
        dragger.gldragNode = 0;
        dragger.fx = 0;
        dragger.fy = 0;
        dragger.dragStartNode = 0;
        dragger.dragStartObject = 0;
        document.body.onmouseup = dragger.tempDOMU;
        document.body.onmousemove = dragger.tempDOMM;
        dragger.tempDOMU = null;
        dragger.tempDOMM = null;
        dragger.waitDrag = 0;
    };
    dhtmlDragAndDropObject.prototype.stopFrameRoute = function (g) {
        if (g) {
            window.dhtmlDragAndDrop.stopDrag(1, 1);
        }
        for (var a = 0; a < window.frames.length; a++) {
            try {
                if (window.frames[a] != g && window.frames[a].dhtmlDragAndDrop) {
                    window.frames[a].dhtmlDragAndDrop.stopFrameRoute(window);
                }
            }
            catch (c) {
            }
        }
        try {
            if (parent.dhtmlDragAndDrop && parent != window && parent != g) {
                parent.dhtmlDragAndDrop.stopFrameRoute(window);
            }
        }
        catch (c) {
        }
    };
    dhtmlDragAndDropObject.prototype.initFrameRoute = function (g, h) {
        if (g) {
            window.dhtmlDragAndDrop.preCreateDragCopy();
            window.dhtmlDragAndDrop.dragStartNode = g.dhtmlDragAndDrop.dragStartNode;
            window.dhtmlDragAndDrop.dragStartObject =
                g.dhtmlDragAndDrop.dragStartObject;
            window.dhtmlDragAndDrop.dragNode = g.dhtmlDragAndDrop.dragNode;
            window.dhtmlDragAndDrop.gldragNode = g.dhtmlDragAndDrop.dragNode;
            window.document.body.onmouseup = window.dhtmlDragAndDrop.stopDrag;
            window.waitDrag = 0;
            if (!window._isIE && h && (!window._isFF || window._FFrv < 1.8)) {
                window.dhtmlDragAndDrop.calculateFramePosition();
            }
        }
        try {
            if (parent.dhtmlDragAndDrop && parent != window && parent != g) {
                parent.dhtmlDragAndDrop.initFrameRoute(window);
            }
        }
        catch (c) {
        }
        for (var a = 0; a < window.frames.length; a++) {
            try {
                if (window.frames[a] != g && window.frames[a].dhtmlDragAndDrop) {
                    window.frames[a].dhtmlDragAndDrop.initFrameRoute(window, !g || h ? 1 : 0);
                }
            }
            catch (c) {
                console.log(c,"-------c--")
            }
        }
    };
    return dhtmlDragAndDropObject;
})();

export default dhtmlDragAndDropObject;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlDragAndDropObject.js